import { Component, InputSignal, input } from '@angular/core';

/**
 * Shared page chrome for the split onboarding profile pages. Its geometry deliberately mirrors
 * `onboarding-concern`, so the doctor and heading stay pinned as the user advances.
 */
@Component({
  selector: 'app-onboarding-profile-shell',
  templateUrl: './onboarding-profile-shell.component.html',
})
export class OnboardingProfileShellComponent {
  /** False removes the footer from the DOM, so it never renders as an empty white bar. */
  readonly showFooter: InputSignal<boolean> = input(true);
}
